import { render, staticRenderFns } from "./channel_home.vue?vue&type=template&id=a31b7d48&"
import script from "./channel_home.vue?vue&type=script&lang=js&"
export * from "./channel_home.vue?vue&type=script&lang=js&"
import style0 from "./channel_home.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports